<template>
  <div class="google-auth-callback">
    <div class="callback-container d-flex flex-column align-center justify-center fill-height">
      <v-progress-circular
        indeterminate
        color="primary"
        size="50"
        class="mb-4"
      ></v-progress-circular>
      <p class="text-h6">Processing Google authentication...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoogleAuthCallback',
  mounted() {
    // Handle the OAuth redirect
    this.handleOAuthRedirect()
  },
  methods: {
    handleOAuthRedirect() {
      try {
        const hash = window.location.hash.substring(1)
        const params = new URLSearchParams(hash)
        const accessToken = params.get('access_token')

        if (accessToken) {
          window.history.replaceState(null, null, ' ')

          localStorage.setItem('google_access_token', accessToken)

          window.opener.postMessage(
            {
              type: 'GOOGLE_AUTH_SUCCESS',
              token: accessToken
            },
            window.location.origin
          )

          // Close the popup if this is a popup window
          if (window.opener) {
            window.close()
          } else {
            // Redirect in the same window
            this.$router.push('/workforce/login')
          }
        } else {
          // Handle error case
          window.opener.postMessage(
            {
              type: 'GOOGLE_AUTH_ERROR',
              error: 'No access token received'
            },
            window.location.origin
          )

          if (window.opener) {
            window.close()
          } else {
            this.$router.push('/workforce/login')
          }
        }
      } catch (error) {
        console.error('Error handling OAuth redirect:', error)
        window.opener.postMessage(
          {
            type: 'GOOGLE_AUTH_ERROR',
            error: error.message
          },
          window.location.origin
        )

        if (window.opener) {
          window.close()
        } else {
          this.$router.push('/workforce/login')
        }
      }
    }
  }
}
</script>

<style scoped>
.google-auth-callback {
  height: 100vh;
}

.callback-container {
  height: 100%;
}
</style>
